<app-associated-card
	[client]="client"
	[association]="_association"
	(deleteClientAssociation)="deleteClientAssociation()"
	(removeAssociations)="removeAssociations($event)"
	(updatePrimaryContactStatus)="updatePrimaryContactStatus($event)"
	(editAssociation)="editAssociation($event)"
	[testHook]="testHooks.AssociatedCard"
></app-associated-card>
